import { convertTZ } from "../date-time/convertTZ";

export function getMinDateAllowedToReserve(
  officeTz: string,
  dates: Date[] = []
) {
  const d = convertTZ(new Date(), officeTz);
  d.setHours(0, 0, 0, 0);
  return [...dates, d].reduce((a, b) => (a < b ? a : b));
}
